import LocationPage from '@/pages/about/LocationPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/about/location')({
  component: RouteComponent,
})

function RouteComponent() {
  return <LocationPage />
}
